import { menuTabUrl } from "./page-url";

// utm_act对应的url
export const ACTIVITY_URL_MAP = {
  "1": "/rummy",
  "2": "/referral-wheel",
  "3": "/affiliate",
  "4": "/casino",
  "5": menuTabUrl.fantasy,
  "99": "/"
};